// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3ffe2d0a] .upload-history {\n  margin-top: 5vh !important;\n}\n[data-v-3ffe2d0a] .upload-history .el-dialog__body {\n  max-height: 100vh !important;\n}\n[data-v-3ffe2d0a] .upload-history .refresh-icon {\n  margin-left: 8px;\n}\n[data-v-3ffe2d0a] .upload-history .refresh-icon:hover {\n  cursor: pointer;\n  color: #1db0fc;\n}", ""]);
// Exports
module.exports = exports;
